<template>
  <div class="loc-product-terpenes">
    <p class="is-size-16px has-text-weight-semibold mb10">Terpenes</p>
    <div class="terpene-tag text-secondary bg-secondary-light" v-bind:key="'terpene_' + terpene.id" v-for="terpene in terpenes">
     {{terpene.name}}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import Env from '@/env';

export default {
  name: 'LocationProductTerpenes',
  data() {
    return {

    };
  },
  
  props:{
    terpenes: {
      required: true,
      type: Array,
    },
  },


  mounted() {

  },
  
  methods: {

  },
};
</script>
